import { Blob, DirectUpload } from "@rails/activestorage";

import { maybeCall } from "./functions";

interface Options {
  file: File;
  /**
   * Callback when blob is created with signed id but file is not uploaded yet.
   */
  onBlob?: (blob: Blob) => void;
  /**
   * Callback when file upload has progress.
   */
  onProgress?: (event: ProgressEvent) => void;
  /**
   * Callback when file upload encounters an error.
   */
  onError?: (error: Error) => void;
  /**
   * Callback when file successfully uploaded.
   */
  onFinish?: (blob: Blob) => void;
}

const DIRECT_UPLOAD_URL = `${import.meta.env.VITE_API_URL}/api/direct_uploads`;

export function directUpload(opts: Options): void {
  const upload = new DirectUpload(opts.file, DIRECT_UPLOAD_URL, {
    directUploadWillCreateBlobWithXHR: (request) => {
      if (opts.onBlob) {
        request.addEventListener("load", () => {
          maybeCall(opts.onBlob, request.response);
        });
      }
    },
    directUploadWillStoreFileWithXHR: (request) => {
      if (opts.onProgress) {
        request.upload.addEventListener("progress", opts.onProgress);
      }
    },
  });
  upload.create((error, blob) => {
    if (error) maybeCall(opts.onError, error);
    if (blob) maybeCall(opts.onFinish, blob);
  });
}
